// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2spKZ{display:-ms-flexbox;display:flex;height:4rem;width:4rem;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border-radius:8px}._2spKZ svg{fill:#452aec;height:2rem;stroke:#452aec}._2VE7b{background:none;border-radius:50%;font-size:2rem;height:4rem;width:4rem}.linkTile--placeholder ._2VE7b{background:#f4f7fa}._3XCcI{background:#fafafa;font-size:14px;font-size:1.4rem;margin:-1.6rem 0;padding:3.2rem;text-align:center}.-EtsA{border:1px solid #e0e8f2;border-radius:8px;padding:1.2rem 1.6rem}", ""]);
// Exports
exports.locals = {
	"avatarFig": "_2spKZ",
	"avatar": "_2VE7b",
	"empty": "_3XCcI",
	"organizationMembershipModalBox": "-EtsA"
};
module.exports = exports;
